import { useEffect, useState } from "react";
import styles from "./alertBannerEditor.module.css"; // External styles
import Marquee from "react-fast-marquee";
import { usePermissionGuard } from '../../adminPanelTools';
import { showInfoToast, showErrorToast } from "../../../../code/ToastHelper";
import { Icons } from "../../../../code/IconHandler";
function AlertBannerEditor() {
    const checking = usePermissionGuard('handle_alert_banner');
    const [blocks, setBlocks] = useState([]);
    const [visible, setVisible] = useState(true);
    const [loading, setLoading] = useState(true);
    const [_, setAuthError] = useState(false);
    const [inputErrors, setInputErrors] = useState({});
    const [validationMessage, setValidationMessage] = useState("");
    // 🔐 Check token and fetch banner
    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            setAuthError(true);
            return;
        }

        fetch("/api/alertbanner/get_alert_banner", {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((res) => {
                return res.json()
            })
            .then((data) => {
                if (data.blocks && Array.isArray(data.blocks)) {
                    setBlocks(data.blocks);
                    setVisible(data.visible);
                }
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    const handleBlockChange = (index, field, value) => {
        const updated = [...blocks];
        if (updated[index].type === "text") {
            updated[index].content = value;
        } else if (updated[index].type === "googleMap") {
            updated[index].url = value;
        }
        setBlocks(updated);
    };

    const addTextBlock = () => {
        setBlocks([...blocks, { type: "text", content: "" }]);
    };

    const addGoogleMapBlock = () => {
        setBlocks([...blocks, { type: "googleMap", url: "" }]);
    };

    const removeBlock = (index) => {
        setBlocks(blocks.filter((_, i) => i !== index));
    };

    const handleSave = async () => {
        const errors = {};

        blocks.forEach((block, index) => {
            if (
                (block.type === "text" && !block.content.trim()) ||
                (block.type === "googleMap" && !block.url.trim())
            ) {
                errors[index] = true;
            }
        });

        if (Object.keys(errors).length > 0) {
            setInputErrors(errors);
            setValidationMessage("Bitte befülle alle Blöcke mit Inhalt oder lösche die entsprechenden Zeilen.");
            return;
        }

        // Clear errors and proceed to save
        setInputErrors({});
        setValidationMessage("");
        const token = localStorage.getItem("token")
        try {
            const res = await fetch("/api/alertbanner/save_alert_banner", {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`, // <-- Add this
                },
                body: JSON.stringify({ blocks, visible }),
            });

            if (!res.ok) throw new Error("Failed to save");
            showInfoToast("Neuer Alertbanner gespeichert!");
        } catch (err) {
            console.error(err);
            showErrorToast("Ein Problem ist beim speichern aufgetreten!");
        }
    };
    const handleMapClick = (url) => {
        window.open(url, "_blank");
    };
    if (checking) {
        return <div className={styles.container}><p>Lade...</p></div>; // or return null if you want no UI at all
    }
    if (loading) return <div className={styles.container}><p>Loading...</p></div>;

    return (
        <div className={styles.container}>
            <h1>AlertBanner-Editor</h1>

            {/* Preview */}
            <div className={styles.previewContainer}>
                <p className={styles.topText}>Aktueller Text:</p>
                <div className={styles.preview}>

                    <Marquee className={styles.banner} pauseOnHover={true}>
                        {blocks.map((block, i) => {
                            if (block.type === "text") {
                                return <p key={i} className={styles.text}>{block.content}</p>;
                            } else if (block.type === "googleMap") {
                                return (
                                    <img
                                        key={i}
                                        tabIndex={0}
                                        src={`/assets/icons/google-map-icon.png`}
                                        alt="Google Maps Icon"
                                        onClick={() => handleMapClick(block.url)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                handleMapClick(block.url);
                                            }
                                        }}
                                        style={{ cursor: "pointer" }}
                                    />
                                );
                            }
                            return null;
                        })}
                    </Marquee>
                </div>
            </div>

            {/* Visibility Toggle */}
            <label className={styles.toggle}>
                <input
                    type="checkbox"
                    checked={visible}
                    onChange={(e) => setVisible(e.target.checked)}
                />{" "}
                Banner anzeigen
            </label>

            {/* Block Editor */}
            <div>
                {blocks.map((block, i) => (
                    <div key={i} className={styles.blockRow}>
                        <img
                            src={
                                block.type === "text"
                                    ? "/assets/icons/txt-icon.png"
                                    : "/assets/icons/google-map-icon.png"
                            }
                            alt={block.type === "text" ? "Text-Icon" : "Google Maps-Icon"}
                            className={styles.blockIcon}
                        />

                        {block.type === "text" ? (
                            <input
                                type="text"
                                placeholder="Inhalt"
                                value={block.content}
                                onChange={(e) => handleBlockChange(i, "content", e.target.value)}
                                className={`${styles.input} ${inputErrors[i] ? styles.inputError : ""}`}
                            />
                        ) : (
                            <input
                                type="text"
                                placeholder="Google Maps URL"
                                value={block.url}
                                onChange={(e) => handleBlockChange(i, "url", e.target.value)}
                                className={`${styles.input} ${inputErrors[i] ? styles.inputError : ""}`}
                            />
                        )}

                        <button onClick={() => removeBlock(i)} className={styles.deleteBtn} title="Löschen">
                            <Icons.Delete />
                        </button>
                    </div>
                ))}
                {validationMessage && (
                    <p className={styles.validationMessage}>{validationMessage}</p>
                )}
                <div className={styles.addButtons}>

                    <button className={styles.button} onClick={addTextBlock}>
                        <Icons.Add style={{ color: "white" }} />
                        <p>Text hinzufügen</p>
                    </button>
                    <button className={styles.button} onClick={addGoogleMapBlock}>
                        <Icons.Add style={{ color: "white" }} />
                        <p>Google Maps Link hinzufügen</p>
                    </button>
                </div>
            </div>

            {/* Save */}
            <div className={styles.saveSection}>
                <button onClick={handleSave} className={styles.saveBtn}>
                    💾 Banner speichern
                </button>
            </div>
        </div>
    );
}

export default AlertBannerEditor;
